export default __webpack_public_path__ + "static/media/SpiceIconOrange.077b5519.svg";